// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  structureId: __t.u64(),
  unitId: __t.string(),
  rentPerDay: __t.u32(),
  notes: __t.string(),
  digest: __t.string(),
  kind: __t.string(),
  floor: __t.u32(),
  x0: __t.f32(),
  z0: __t.f32(),
  x1: __t.f32(),
  z1: __t.f32(),
  tx: __t.f32(),
  tz: __t.f32(),
  ax: __t.f32(),
  az: __t.f32(),
  ox: __t.f32(),
  oz: __t.f32(),
  keys: __t.array(__t.string()),
};
